<template>
	<b-modal
		hide-footer
		:no-close-on-backdrop="true"
		ref="modal-view"
		size="lg"
		title="Selecciona un proveedor"
	>
		<form @submit="onSubmit">
			<b-row>
				<b-col sm="12">
					<b-form-group label="Proveedor">
						<b-form-select v-model="selected" :options="options" class="mt-2" required/>
					</b-form-group>
				</b-col>
				<b-col class="mt-3">
					<b-button block variant="info" type="submit">Acceder</b-button>
				</b-col>
			</b-row>
		</form>
	</b-modal>
</template>

<script>
import Resize from "../../helpers/Resize.js";

export default {
	mixins: [Resize],
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {
			}
		}
	},
	components: {},
	data() {
		let opts = {}
		return {
			selected: null,
			Opts: {...opts},
			loading: true,
		};
	},
	computed: {
		options() {
			if (Array.isArray(this.Opts.supplier)) {
				return this.Opts.supplier.map(item => ({
					value: item.id,
					text: item.code
				}))
			} else {
				return []
			}
		},
	},
	methods: {
		loadModel(options) {
			this.$refs["modal-view"].show();
			this.Opts = options
		},

		onSubmit(event) {
			event.preventDefault()
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			this.loading = true

			this.$root.api.post('/auth/system', null, {
				headers: {
					"X-SC-TYPE": 'supplier',
					"X-SC-SYSTEM": this.selected,
				}
			}).then((response) => {
				this.$root.store.setSystemData(response.data)

				this.$root.api.post('/auth/me').then((response2) => {
					this.$root.store.setUserData(response2.data)
					this.$router.push('/')
				})
			}).catch(() => {
				this.loading = false;
				this.error = true;
			})
		},
	},
	mounted() {
		console.log("mounted single (?");
	}
};
</script>

<style></style>
